// Tracks when the user last interacted with the chat page (typing, clicking,
// touching, wheel scrolling). Only input events count: the message list
// scrolls itself when messages arrive, so scroll events would keep an
// unattended session alive, and so would a pointer merely resting on the
// page. Kept outside React state: it is read once per token, so it must not
// cause re-renders.
const ACTIVITY_EVENTS = ['keydown', 'pointerdown', 'touchstart', 'wheel'];
const LISTENER_OPTIONS = { capture: true, passive: true };
const RECORD_INTERVAL_MS = 1000;

let lastActivityAt = Date.now();
let isTracking = false;

// Throttled to once a second: wheel fires many times per gesture.
const recordActivity = () => {
  const now = Date.now();
  if (now - lastActivityAt >= RECORD_INTERVAL_MS) lastActivityAt = now;
};

// Events inside an embedded frame (the cross-origin appointment iframes)
// never reach this window; the window only loses focus when the user clicks
// into one. That click counts as activity. Focus merely staying in the frame
// does not, or a user who walked away mid-form would never be idle.
const recordFocusIntoFrame = () => {
  if (document.activeElement?.tagName === 'IFRAME') lastActivityAt = Date.now();
};

// Opening the chat counts as activity.
export const startActivityTracking = () => {
  if (isTracking) return;
  isTracking = true;
  lastActivityAt = Date.now();
  ACTIVITY_EVENTS.forEach((type) => window.addEventListener(type, recordActivity, LISTENER_OPTIONS));
  window.addEventListener('blur', recordFocusIntoFrame, LISTENER_OPTIONS);
};

export const stopActivityTracking = () => {
  if (!isTracking) return;
  isTracking = false;
  ACTIVITY_EVENTS.forEach((type) => window.removeEventListener(type, recordActivity, LISTENER_OPTIONS));
  window.removeEventListener('blur', recordFocusIntoFrame, LISTENER_OPTIONS);
};

// True when the user interacted within the last windowMs (the idle threshold).
export const wasActiveWithin = (windowMs, nowMs = Date.now()) => nowMs - lastActivityAt <= windowMs;
